Hop.defineModule('load-css-file', (root, {href}) => {
    const style = document.createElement('link');
    style.setAttribute('href', href);
    style.setAttribute('rel', 'stylesheet');
    style.setAttribute('type', 'text/css');
    document.getElementsByTagName('head')[0].appendChild(style);
});
